<template>
	<div>
		<CubePage type="myorder-view" :title="title" >
			<div slot="content" class="content">
				<div style="margin:20px 15px; box-sizing: border-box;font-size: 14px;overflow: hidden;">
					<div v-if="nr != null" style="white-space: pre-wrap;line-height: 25px;" v-html="nr"></div>
<!--					<div v-else>
						<div v-if="title=='联系我们'">
							<p>24小时客服热线：0837-7735566</p>
							<p>24小时值班电话：18081129177</p>
							<p>客服及商务合作：13558589299（微信同号）</p>
						</div>
						<div v-else>
							<h4 style="margin-bottom: 20px;">逸泊旅行&#45;&#45;专注同行分销</h4>

							<p>我们是一个同行分销平台</p>
							<p>产品涵盖晚会票、门票、酒店、用车等</p>
							<p>目前只开放了部分产品，更多产品敬请期待！</p>
							<p>后期我们还将推出微信小店铺</p>
							<p>让每个分销者都有属于自己的直销平台</p>
							<p>我们所有产品均为直接采购一手资源</p>
							<p>我们只加价3-10%手续费</p>
							<p>让您利益最大化</p>
							<p>让您赚的更多！</p>
							<p>平台采用电子商务模式</p>
							<p>摒弃传统电话、微信等模式</p>
							<p>让您预订更方便，更快捷！</p>
						</div>
					</div>-->
				</div>

			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				title: this.$route.query.n,
				// title:"四姑娘山景区直通车发车啦!欢迎旅行社采购!",
				nr: null
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				let that = this;
				var url = "/addons/litestore/api.account/sysNotice"
				/*var url = "/addons/litestore/api.account/getContact"
				if(that.title=='2'){
					url = "/addons/litestore/api.account/getAbout"
				}*/
				//这里直接调用网络接口
				util.post(url, {place:this.$route.query.place,id:this.$route.query.id},
					function(result) {
						that.nr=result.data.content
						that.title=result.data.title
					},
				);
			}
		}
	}
</script>
<style lang="less" scoped="scoped">

</style>
